module.exports = __webpack_public_path__ + "static/images/card-bg-2-type3.6a1914d.png";